<template>
    <div class="stock_in_Detail">
        <el-form  ref="addForm" :rules="rules" :model="addForm" style="width:100%;" class="add_form">
            <el-card class="table_searchbar">
            <el-row >
                <el-col :span='5'>
                    <div class="">
                        <span class="title">入库单号：</span>
                        <el-form-item style="display:inline-block">
                            <el-input style="max-width:180px;" :disabled="true"  v-model="addForm.stockInCode" placeholder="入库单号"></el-input>
                        </el-form-item>
                    </div>
                </el-col>

                <el-col :span='5'>
                    <div class="">
                        <span class="title">入库类型：</span>
                        <el-form-item style="display:inline-block">
                            <el-select size="small" @change="stockTypeChange" style="max-width:180px;" v-model="addForm.stockInType" placeholder="入库类型" filterable>
                                <el-option v-for="item in stockTypeOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-col>
                
                <el-col :span='5'>
                    <div class="">
                        <span class="title">入库时间：</span>
                        <el-form-item prop="stockInTime" :rules="rules.stockInTime" style="display:inline-block">
                            <el-date-picker style="width:186px;" v-model="addForm.stockInTime" type="datetime"  value-format='yyyy-MM-dd HH:mm:ss' placeholder="选择日期时间"></el-date-picker>
                        </el-form-item>                    
                    </div>
                </el-col>

                <el-col :span="5">
                    <div class="">
                        <span class="title">仓库：</span>
                        <el-form-item prop="warehouseId" :rules="rules.warehouseId" style="display:inline-block">
                            <el-select @change="warehouseChange" size="small"  style="max-width:180px;" v-model="addForm.warehouseId" placeholder="仓库" filterable>
                                <el-option v-for="item in warehouseList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="5">
                    <div class="">
                        <span class="title">库位：</span>
                        <el-form-item prop="factoryId" :rules="rules.factoryId" style="display:inline-block">
                            <el-select  size="small" style="max-width:180px;" v-model="addForm.factoryId" placeholder="库位" filterable>
                                <el-option v-for="item in factoryList" :key="item.factoryId" :label="item.factoryName" :value="item.factoryId"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </el-col>
                <el-col :span='5'>
                    <div class="">
                        <span class="title">申请人：</span>
                        <el-form-item prop="applicantId" :rules="rules.applicantId" style="display:inline-block">
                            <el-select  size="small" style="max-width:180px;" v-model="addForm.applicantId" placeholder="申请人" filterable>
                                <el-option v-for="item in applicantList" :key="item.id" :label="item.label" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                                     
                    </div>
                </el-col>
            </el-row>
        </el-card>
        <el-card class="table-card" >
            <el-row style="margin-bottom:20px" >
                <el-button type="primary" icon="el-icon-plus" size="small" @click="addMaterial" v-if='!(addForm.data.length==1&&addForm.stockInType==3)'>新增物料</el-button> 
            </el-row>

            <el-table v-if="addForm.stockInType&&addForm.stockInType!=4" class="stock-material" :data='addForm.data' border maxHeight="500">
                <el-table-column label="批次号" min-width="110" >
                    <template slot-scope="scope">
                        <el-form-item :prop="`data[${scope.$index}].productionBatchCode`" :rules="rules.productionBatchCode" style="display:inline-block">
                            <el-select :loading="loading"  :remote-method="query=>{remoteMethod(query,scope.$index)}" remote filterable clearable @change="productionBatchChange($event,scope.$index)"  v-model="scope.row.productionBatchCode"  placeholder="批次号" style="display:block">
                                <el-option v-for="item in productionBatchCodeList[scope.$index]" :key="item.productionBatchCode" :label="item.productionBatchCode" :value="item.productionBatchCode"></el-option>
                            </el-select>
                        </el-form-item>
                    </template>
                </el-table-column>

                <el-table-column label="物料编码" min-width="110" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-form-item  style="display:inline-block">
                           {{scope.row.materialCode}}
                        </el-form-item>
                    </template>
                </el-table-column>
                
                 <el-table-column label="物料名称" min-width="110" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-form-item  style="display:inline-block">
                           {{scope.row.materialName}}
                        </el-form-item>
                    </template>
                </el-table-column>

                 <el-table-column label="规格" min-width="110" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-form-item  style="display:inline-block">
                           {{scope.row.specification}}
                        </el-form-item>
                    </template>
                </el-table-column>

                <el-table-column label="数量" min-width="110" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-form-item :prop="`data[${scope.$index}]`" :rules="rules.itemAmount" style="display:inline-block">
                            <el-input v-model="scope.row.amount" placeholder="入库数量"></el-input>
                        </el-form-item>
                    </template>
                </el-table-column>


                <el-table-column label="单位" min-width="110" show-overflow-tooltip v-if='addForm.stockInType==3'>
                    <template slot-scope="scope" v-if='addForm.stockInType==3'>
                        <el-form-item  style="display:inline-block" v-if='addForm.stockInType==3'>
                            <el-select filterable clearable   v-model="scope.row.unitTypeId"  placeholder="单位" style="display:block">
                                <el-option v-for="item in scope.row.unitTypeList" :key="item.unitTypeId" :label="item.unitOfQuantity" :value="item.unitTypeId"></el-option>
                            </el-select>
                        </el-form-item>
                    </template>
                </el-table-column>

                <el-table-column label="单位" min-width="110" show-overflow-tooltip v-if='addForm.stockInType==1'>
                    <template slot-scope="scope" v-if='addForm.stockInType==1'>
                        <el-form-item v-if='addForm.stockInType==1'>
                            {{scope.row.unitOfQuantity}}
                        </el-form-item>
                    </template>
                </el-table-column>

                <el-table-column label="操作" width="50">
                    <template slot-scope="scope">
                        <div class="delete" type="primary" @click="deleteMaterial(scope.$index)"></div>
                    </template>
                </el-table-column>
            </el-table>

            <el-table v-if="addForm.stockInType&&addForm.stockInType==4" class="stock-material" :data='addForm.data' border maxHeight="500">
                <el-table-column label="物料编码" min-width="110" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-form-item :prop="`data[${scope.$index}].materialId`" :rules="rules.materialId" style="display:inline-block">
                            <el-select :loading="loading"  :remote-method="query=>{materialRemoteMethod(query,'','',scope.$index)}" remote filterable clearable @change="materialChange($event,scope.$index)"  v-model="scope.row.materialId"  placeholder="物料编码" style="display:block">
                                <el-option v-for="item in materialList[scope.$index]" :key="item.id" :label="item.materialCode" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </template>
                </el-table-column>
                
                 <el-table-column label="物料名称" min-width="110" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-form-item :prop="`data[${scope.$index}].materialId`" :rules="rules.materialId" style="display:inline-block">
                            <el-select :loading="loading"  :remote-method="query=>{materialRemoteMethod('',query,'',scope.$index)}" remote filterable clearable @change="materialChange($event,scope.$index)"  v-model="scope.row.materialId"  placeholder="物料名称" style="display:block">
                                <el-option v-for="item in materialList[scope.$index]" :key="item.id" :label="item.materialName" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </template>
                </el-table-column>

                 <el-table-column label="规格" min-width="110" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-form-item :prop="`data[${scope.$index}].materialId`" :rules="rules.materialId" style="display:inline-block">
                            <el-select :loading="loading"  :remote-method="query=>{materialRemoteMethod('','',query,scope.$index)}" remote filterable clearable @change="materialChange($event,scope.$index)"  v-model="scope.row.materialId"  placeholder="规格" style="display:block">
                                <el-option v-for="item in materialList[scope.$index]" :key="item.id" :label="item.specification" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </template>
                </el-table-column>

                <el-table-column label="数量" min-width="110" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-form-item :prop="`data[${scope.$index}]`" :rules="rules.itemAmount" style="display:inline-block">
                            <el-input v-model="scope.row.amount" placeholder="入库数量"></el-input>
                        </el-form-item>
                    </template>
                </el-table-column>


                <el-table-column label="单位" min-width="110" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-form-item  style="display:inline-block" >
                            <el-select filterable clearable @change="unitTypeSelect($event,scope.row)"  v-model="scope.row.unitTypeId"  placeholder="单位" style="display:block">
                                <el-option v-for="item in scope.row.unitTypeList" :key="item.unitTypeId" :label="item.unitOfQuantity" :value="item.unitTypeId"></el-option>
                            </el-select>
                        </el-form-item>
                    </template>
                </el-table-column>

                <el-table-column label="操作" width="50">
                    <template slot-scope="scope">
                        <div class="delete" type="primary" @click="deleteMaterial(scope.$index)"></div>
                    </template>
                </el-table-column>
            </el-table>
            
            <el-row style="margin:20px 0 0px 0;text-align: center;">
                <el-button type="primary" size="small" @click="backToOrderView">返回</el-button>
                <el-button type="primary" size="small" @click="submit">提交</el-button>
            </el-row>
        </el-card>
        </el-form>
    </div>
</template>
<script>
import CommonUtils from '../../util/CommonUtils'
export default {
    name: 'StockInEdit',
    props: {
        selectedInfo: Object,
    },
    data() {
        return {
            stockTypeOption:[// 1生产 3采购 4直接
				{label:'生产入库',value:1},
				{label:'采购入库',value:3},
				{label:'直接入库',value:4},
			],
            factoryList:[],
            warehouseList:[],
            productionBatchCodeList:[],
            productionBatchCodeBaseList:[],
            materialList:[],
            materialBaseList:[],
            W: false,
            loading: false,
            addForm: {
                stockInType:null,
                warehouseId:null,
                factoryId:null,
                stockInTime:null,
                stockInCode:'',
                applicantId:null,
                data: [],
            },
            applicantList:[],
            rules: {
                materialId: [
                    { required: true, message: '请选择物料编码', trigger: 'blur' }
                ],
                productionBatch: [
                    { required: true, message: '请选择物料批次', trigger: ['input',] }
                ],
                warehouseId: [
                    { required: true, message: '请选择仓库', trigger: 'blur' }
                ],
                applicantId: [
                    { required: true, message: '请选择申请人', trigger: 'blur' }
                ],
                itemAmount: [
                    { required: true, message: '请输入入库数量', trigger: ['blur', 'input'] },
                    {   validator(rule, item, callback) {
                            let value = item.amount
                            if (Number(value) > 0) {
                                if(item.ratio&&item.maxAmount&&item.maxAmount>0){
                                    item.maxAmount = item.ratio*item.maxAmount
                                }
                                if (item.maxAmount!=null && item.maxAmount < Number(value)) {
                                    callback(new Error(`数量不能大于可入库数量(${item.maxAmount})`))
                                } else {
                                    callback()
                                }
                            } else {
                                callback(new Error('入库数量必须大于零'))
                            }
                        }, trigger: ['blur', 'input']                    }
                ],
                factoryId: [
                    { required: true, message: '请选择库位', trigger: 'blur' }
                ],
            },
        }
    },
    mounted: async function () {
        this.addForm = CommonUtils.cloneObj(this.selectedInfo)
        
        this.loadStockInCodeList()
        this.loadApplicantList()
        this.initData()
        let w = document.documentElement.clientWidth || document.body.clientWidth;
        w >= 1900 ? this.W = true : this.W = false
        window.onresize = () => {
            let w = document.documentElement.clientWidth || document.body.clientWidth;
            w >= 1900 ? this.W = true : this.W = false
        }
    },
    computed: {
        span() {
            return this.W ? 5 : 7
        }
    },
    deactivated: function () {
        console.log("deactivated");
    },
    methods: {
        loadApplicantList(){
            this.$RequestUtil.post({
                url: '/api/select/listWorker',
                params: {},
                type:'sync',
                success: (res) => {
                    if(res.code == 0){
                        this.applicantList = res.data;
                    }
                }
            });
        },

        async initData(){
            
            if(this.addForm.stockInType==4){
                this.materialBaseList = await this.loadMaterialList()
                this.addForm.data.forEach(async (item,index) => {
                    
                    let find = this.materialBaseList.find(f=>f.id==item.materialId)
                    if(find){
                        this.$set(this.materialList,index,CommonUtils.cloneObj(this.materialBaseList))
                        item.unitTypeList = find.unitTypeList
                    }else{
                        let list = await this.loadMaterialList(item.materialCode)
                       this.$set(this.materialList,index,list) 
                       item.unitTypeList = (list[0]||[{}]).unitTypeList
                    }
                });
            }else{
                this.productionBatchCodeBaseList = await this.loadBatchList()
                this.addForm.data.forEach(async (item,index) => {
                    let find = this.productionBatchCodeBaseList.find(f=>f.productionBatchCode==item.productionBatchCode)
                    if(find){
                        this.$set(this.productionBatchCodeList,index,CommonUtils.cloneObj(this.productionBatchCodeBaseList))
                        item.unitTypeList = find.unitTypeList
                    }else{
                       this.$set(this.productionBatchCodeList,index,await this.loadBatchList(item.productionBatchCode)) 
                       item.unitTypeList = (await this.loadBatchList(item.productionBatchCode)||[{}]).unitTypeList
                    }
                    
                });
            }
            await this.loadWarehouseLocationByWarehouseId(this.addForm.warehouseId)
        },
        
        async loadStockInCodeList(id) {
            let {data} = await this.$RequestUtil.getAsync({ url: '/api/select/listDefaultMaterialFactoryModel',  params: { id }, })
            this.warehouseList = data
        },
        
        async loadWarehouseLocationByWarehouseId(warehouseId) {
            let {data} = await this.$RequestUtil.getAsync({ url: '/api/select/getWarehouseLocationSelect',  params: { warehouseId }, })
            this.factoryList = data
		},

        async warehouseChange(ev){
            this.$set(this.addForm,'factoryId',null)
            await this.loadWarehouseLocationByWarehouseId(ev)
        },

        async stockTypeChange(){
           
            if(this.addForm.stockInType==4){
                this.materialBaseList = await this.loadMaterialList()
                this.$set(this.materialList,0,CommonUtils.cloneObj(this.materialBaseList))
            }else{
                this.productionBatchCodeBaseList = await this.loadBatchList()
                this.$set(this.productionBatchCodeList,0,CommonUtils.cloneObj(this.productionBatchCodeBaseList))
            }
        },
        
         unitTypeSelect(ev,row){
            row.ratio = (row.unitTypeList.find(item=>item.unitTypeId==ev)||{ratio:1}).ratio
        },
        productionBatchChange(ev,index){
            let json = this.productionBatchCodeList[index].find(item=>item.productionBatchCode==ev)||{}

            this.$set(this.addForm.data,index,CommonUtils.cloneObj(json))
        },

        async loadBatchList(productionBatchCode){
            let {data} = await this.$RequestUtil.getAsync({ url: '/api/select/productionBatchCodeSelect',  params: { stockInType:this.addForm.stockInType, productionBatchCode}, })
            return data
        },


        async remoteMethod(query,index) {
            this.loading = true
            let data = await this.loadBatchList(query)
            this.productionBatchCodeList[index] = data
            this.loading = false
        },

        async loadMaterialList(materialCode,materialName,specification) {
            let {data} = await this.$RequestUtil.getAsync({ url: '/api/select/listMaterial', params: {materialCode,materialName,specification,stockInType:4} })
            return data
        },

        async materialRemoteMethod(code,nane,model,index){
            this.loading = true
            let data = await this.loadMaterialList(code,nane,model)
            this.materialList[index] = data
            this.loading = false
        },

        materialChange(ev,index){
            let json = this.materialList[index].find(item=>item.id==ev)||{}
            this.$set(this.addForm.data[index],'unitTypeId',json.unitTypeId)
            this.$set(this.addForm.data[index],'unitTypeList',json.unitTypeList)
            
        },
        
        submit() {
            this.addForm.stockInDetailVOS = this.addForm.data
            this.$refs['addForm'].validate((valid) => {
                if (valid) {
                    this.$RequestUtil.post({
                        url: '/api/stock/update/stockIn',
                        type: 'sync',
                        params: this.addForm,
                        success: res => {
                            if (res.code == 0) {
                                this.$message.success('修改成功')
                                this.backToOrderView()
                               
                            } else {
                                this.$message.error(res.message || res.msg)
                            }
                        }
                    })
                }
            })
        },
    
        deleteMaterial(index) {
            this.addForm.data.splice(index, 1);
            if(this.addForm.stockInType==4){
                this.materialList.splice(index,1)
            }else{
                this.productionBatchCodeList.splice(index,1)
            }
            
        },

        addMaterial() {
            if (!this.addForm.stockInType) {
                this.$message.warning('请选择入库类型')
                return
            }
            let len = this.addForm.data.length
            this.addForm.data.push({})
            if(this.addForm.stockInType==4){
                this.$set(this.materialList,len,CommonUtils.cloneObj(this.materialBaseList))
            }else{
                this.$set(this.productionBatchCodeList,len,CommonUtils.cloneObj(this.productionBatchCodeBaseList))
            }
        },

        backToOrderView() {
            this.$parent.reload()
            this.$parent.showPage = 1;
        },
    }
}
</script>
<style scoped>

.value {
    display: inline-block;
}
.stock_in_Detail {
    width: 100%;
    height: 100%;
}
.delete {
    width: 18px;
    height: 19px;
    background-image: url("../../../static/img/del.png");
    cursor: pointer;
    background-repeat: no-repeat;
    margin-left: 4px;
}
.add {
    width: 19px;
    height: 19px;
    background-image: url("../../../static/img/add.png");
    cursor: pointer;
    background-repeat: no-repeat;
}
.delete:hover {
    background-image: url("../../../static/img/del-hover.png");
    background-repeat: no-repeat;
}
</style>
<style>
.select_width {
    width: 139px;
}
.stock_in_Detail .add {
    width: 19px;
    height: 19px;
    background-image: url("../../../static/img/add.png");
    cursor: pointer;
    background-repeat: no-repeat;
    margin-top: 10px;
}
.stock_in_Detail .el-form-item--mini.el-form-item,
.stock_in_Detail .el-form-item--small.el-form-item {
    margin-top: 7px;
    margin-bottom: 13px;
}
.stock-material::before {
    /* background-color: #fff !important; */
    border: none;
    display: none;
}
</style>





// WEBPACK FOOTER //
// src/views/stock/StockInEdit.vue